import { DateTime } from 'luxon';
import { useEffect } from 'react';
import { queryRefetchService } from 'services/QueryRefetchService';
import { getCurrentlySelectedLocation } from 'utils/getCurrentlySelectedLocation';

interface UseBiddingTimeProps {
  biddingTimeEndsAt: string | null;
  timeZone?: string | null;
  orderRelayId: string;
}

export function useBiddingTime({
  biddingTimeEndsAt,
  timeZone: orderTimeZone,
  orderRelayId,
}: UseBiddingTimeProps) {
  const oneMinDelayInMs = 60 * 1000;
  const { timeZone: selectedLocationsTimeZone } = getCurrentlySelectedLocation();

  const timeZone = orderTimeZone || selectedLocationsTimeZone;
  useEffect(() => {
    if (!biddingTimeEndsAt || !timeZone) return;

    const biddingEndTime = DateTime.fromISO(biddingTimeEndsAt).setZone(timeZone);
    const currentTime = DateTime.now();
    const remainingBiddingTime = biddingEndTime.toMillis() - currentTime.toMillis();

    if (remainingBiddingTime > 0) {
      const biddingPeriodTimeout = setTimeout(() => {
        queryRefetchService.refetchDataQueryByKey('SHIFT_CARD', `${orderRelayId}`);
      }, remainingBiddingTime + oneMinDelayInMs);
      return () => {
        clearTimeout(biddingPeriodTimeout);
      };
    }
  }, [timeZone, biddingTimeEndsAt, orderRelayId, oneMinDelayInMs]);
}
